var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,_vm._g(_vm._b({tag:"component",staticClass:"icon-button",class:_vm.modifiers},'component',_vm.attributes,false),_vm.$listeners),[_c('BaseIcon',{staticClass:"icon-button__svg",attrs:{"name":_vm.icon}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }